<template>
  <div
    class="course_item fl"
    @click="onClick"
  >
    <div class="course_item_content">
      <div
        v-if="datas.courseCover || datas.cover"
        class="item_image_wrapper"
      >
        <img
          class="item_image"
          :src="(datas.courseCover || datas.cover)"
        >
        <div class="yearText" v-if="datas.batchNo || (datas.menuType==1&&datas.trainingYear)">
          {{ datas.menuType==1? datas.trainingYear + '年度': datas.batchNo }}
        </div>
        <!--        <div class="course_type">-->
        <!--          {{ courseTypeEnum[datas.courseType || datas.goodsType] }}-->
        <!--        </div>-->

        <!--        <div class="image-view">-->
        <!--          <div class="line-view"></div>-->

        <!--          <div class="course-title">-->
        <!--            {{ datas.courseName || datas.goodsName }}-->
        <!--          </div>-->

        <!--          <div class="course-author">-->
        <!--            <span>主讲人：</span>-->
        <!--            <p>王想</p>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div class="course_desc">
        <div
          class="item_text tx-ov"
          v-html="datas.courseName || datas.goodsName"
        />

        <div class="course_detail">
          <!-- <div class="course-author tx-ov">
            课程作者：{{ datas.courseAuthor || datas.teacherName || '暂无' }}
          </div> -->
          <div class="course-author tx-ov">
            <span style="color:#1b75d5;">共{{datas.resourceCount===0?1:datas.resourceCount}}门课</span><span class="xueshi">{{datas.credit}}学时</span>
          </div>

          <div
            v-if="(shopData?.config?.showLearnUserCount && shopData?.config?.showCourseLearnUserCount && datas.courseType)"
            class="course-people"
          >
            <img
              src="@/assets/images/new/rentu@2x.png"
              alt=""
              style="width: 13px;height: 15px"
            >
            <div
              v-if="datas.courseType === 6"
              class="course_sale"
            >
              {{ (datas.saleCount || 0) + '人' }}
            </div>
            <div
              v-else
              class="course_sale"
            >
              {{ (datas.studyNum || 0) + '人' }}
            </div>
          </div>
        </div>
        <div class="course_detail">
          <div class="price">
            <span
              v-if="componentInfo.config.isVipModal"
              class="current_price"
              :class="{'free': !datas.vipPrice}"
            >{{ datas.vipPrice || '免费' }}</span>
            <span
              v-else
              class="current_price"
              :class="{'free': datas.price == 0}"
            >{{ datas.price || '免费' }}</span>
            <!--            <span-->
            <!--              v-if="datas.linePrice != 0"-->
            <!--              class="old_price"-->
            <!--            >{{ datas.linePrice }}</span>-->
          </div>

          <!--          <template v-if="(!datas.courseStatus && datas.buyStatus) || !datas.price">-->
          <!--            <template v-if="datas.courseType == 1">-->
          <!--&lt;!&ndash;              TODO 返回数据缺少liveStatus&ndash;&gt;-->
          <!--              <el-button-->
          <!--                v-if="datas.liveStatus === 1 || datas.liveStatus === 3"-->
          <!--                class="buy_btn"-->
          <!--                plain-->
          <!--                size="small"-->
          <!--                disabled-->
          <!--              >-->
          <!--                {{ datas.liveStatus === 1 ? "未开播" : "已结束" }}-->
          <!--              </el-button>-->
          <!--              <el-button-->
          <!--                v-else-->
          <!--                class="buy_btn"-->
          <!--                plain-->
          <!--                size="small"-->
          <!--              >-->
          <!--                {{ datas.liveStatus === 2 ? "进入直播" : "查看回放" }}-->
          <!--              </el-button>-->
          <!--            </template>-->
          <!--            <el-button-->
          <!--              v-else-->
          <!--              class="buy_btn"-->
          <!--              plain-->
          <!--              size="small"-->
          <!--              @click.stop="handleBuy"-->
          <!--            >-->
          <!--              {{ !datas.enableFirst ? "继续学习" : "开始学习" }}-->
          <!--            </el-button>-->

          <!--          </template>-->

          <el-button
            v-if="config.isShowShoppingCart&&!datas.courseStatus && !datas.buyStatus && datas.price"
            class="cart_btn"
            type="warning"
            @click.stop="onTrolley"
          >
            加入购物车
          </el-button>
          <el-button
            v-else
            class="buy_btn"
            type="warning"
            @click.stop="learnClick"
          >
            开始学习
          </el-button>
        </div>
      </div>
    </div>
    <el-dialog
      v-model="dialogShow"
      append-to-body
      width="400px"
      title="温馨提示"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        {{ dialogText }}
        <span v-if="dialogType == 1">
          课程日前已经无法购买。
        </span>
        <span v-else>
          该年度未完成学习的课程仍可正常学习，但无法正常获取学时。
        </span>
      </div>
      <div class="offline_btn">
        <div
          class="btn2"
          @click="dialogShow = false"
        >
          取消
        </div>
        <div
          class="btn"
          @click="dialogClick"
        >
          确定
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useUserStore } from '@/stores/user'
import config from '@/config/index'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { courseAuthAppointment, getValid, courseSaveStarAuthResource } from '../../../api/course'
import { trolleyAdd } from '../../../api/trolley'
import { useCartStore } from '@/stores/cart'

const prop = defineProps({
  datas: {
    type: Object
  },
  courseTypeEnum: {
    type: Object,
    default: {
      1: '直播课',
      2: '视频课',
      3: '音频课',
      4: '图文课',
      5: '专题课',
      6: '套餐',
      7: '课程包'
    }
  },
  componentInfo: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const router = useRouter()
const route = useRoute()
const cartStore = useCartStore()
const { shopData, getToken } = useUserStore()
const store = useUserStore()
const token = computed(() => {
  return getToken()
})
const userInfo = computed(() => {
  return store.userView
})
const dialogShow = ref(false)
const dialogType = ref('')
const dialogText = ref('')
const urlStr = ref('')
const dialogClick = () => {
  if (dialogType.value !== 1) {
    window.open(urlStr.value)
  }

  dialogShow.value = false
  // dialogText.value = ''
}
const learnClick = () => {
  const typeObj = {
    1: 'live',
    2: 'video',
    3: 'audio',
    4: 'graphic',
    5: 'subject',
    6: 'topic',
    7: 'package'
  }
  const url = `/course/${typeObj[(prop.datas.courseType || prop.datas.goodsType)]}?id=${prop.datas.id || prop.datas.goodsId}`
  // window.open(window.location.protocol + '//' + window.location.host + url)
  urlStr.value = window.location.protocol + '//' + window.location.host + url

  if (token.value) {
    if (prop.datas.courseType === 7 && prop.datas.price === 0) {
      courseSaveStarAuthResource({
        userId: userInfo.value.id,
        courseId: prop.datas.id
      }).then(ress => {
        getValid({ courseId: prop.datas.id }).then(res => {
          if (typeof res === 'string') {
            dialogShow.value = true
            dialogText.value = res
            dialogType.value = 2
          } else {
            window.open(urlStr.value)
          }
        })
      })
    } else {
      getValid({ courseId: prop.datas.id }).then(res => {
        if (typeof res === 'string') {
          dialogShow.value = true
          dialogText.value = res
          dialogType.value = 2
        } else {
          window.open(urlStr.value)
        }
      })
    }
  } else {
    router.push({
      path: '/login',
      query: {
        redirect: encodeURIComponent(route.fullPath)
      }
    })
  }
}
const onClick = () => {
  const typeObj = {
    1: 'live',
    2: 'video',
    3: 'audio',
    4: 'graphic',
    5: 'subject',
    6: 'topic',
    7: 'package'
  }
  const url = `/course/${typeObj[(prop.datas.courseType || prop.datas.goodsType)]}?id=${prop.datas.id || prop.datas.goodsId}`
  window.open(window.location.protocol + '//' + window.location.host + url)
  // router.push(`/course/${typeObj[(prop.datas.courseType || prop.datas.goodsType)]}?id=${prop.datas.id || prop.datas.goodsId}`)
}

const handleBuy = () => {
  // 购买
  if (!handleBeforeValid()) {
    return false
  }
  if (prop.datas.courseStatus === 1) {
    handleMake()
    return
  }
  if (prop.datas.courseStatus === 2) {
    return
  }
  if (prop.datas.courseStatus === 3) {
    handleOpenOther()
    return
  }
  if (prop.datas.price > 0 && !prop.datas.buyStatus) {
    if (!shopData.config.enabledPay) {
      ElMessage.error(shopData.config.disablePayTips)
      return
    }
    if (!shopData.config.enabledAliPay && !shopData.config.enabledWxPay) {
      ElMessage.error(shopData.config.disablePayTips)
      return
    }
  }
  if (!(prop.datas.price > 0 && !prop.datas.buyStatus)) {
    if (
      !prop.datas.enableNotLoginWatch &&
      !prop.datas.buyStatus &&
      prop.datas.price === 0 &&
      !token.value
    ) {
      ElMessage.error('请登录后再进行观看')
      router.push({
        path: '/login',
        query: {
          redirect: encodeURIComponent(route.fullPath)
        }
      })
      return
    }
    const query = route.query || {}
    router.push({
      path: '/course/single',
      query: Object.assign(query, { id: prop.datas.id })
    })
  }
}

const handleBeforeValid = () => {
  // 课程是否已过期
  if (prop.datas.courseStatus === 3) {
    ElMessage.error('课程已过期')
    return false
  } else {
    return true
  }
}

const handleMake = () => {
  // 预约
  if (!token.value) {
    router.push({
      path: '/login',
      query: {
        redirect: encodeURIComponent(route.fullPath)
      }
    })
    return
  }
  courseAuthAppointment({ id: prop.datas.id }).then((res) => {
    if (res) {
      ElMessageBox.alert(
        '课程开课时，我们将以短信的形式通知您，请您留意哟~',
        '预约成功提醒',
        {
          confirmButtonText: '知道了',
          type: 'success',
          center: true
        }
      )
      prop.datas.courseStatus = 2
    }
  })
}

const handleOpenOther = () => {
  router.push({
    path: '/course/list'
  })
}

const onTrolley = () => {
  if (token.value) {
    getValid({ courseId: prop.datas.id }).then(res => {
      if (typeof res === 'string') {
        dialogShow.value = true
        dialogText.value = res
        dialogType.value = 1
      } else {
        trolleyAdd(prop.datas.id).then(res => {
          console.log(res)
          ElMessage.success('添加成功')
          cartStore.updateCartNum()
        }).catch(err => {
          console.log(err)
        })
      }
    })
  } else {
    router.push({
      path: '/login',
      query: {
        redirect: encodeURIComponent(route.fullPath)
      }
    })
  }
}

</script>

<style scoped lang="scss">
.course_item_wrapper {
  margin-right: -10px;
  margin-left: -10px;

  .course_item_ad {
    width: 20%;
    padding-left: 10px;
    padding-right: 10px;

    .item_image_wrapper {
      height: 100%;
    }

  }

}

.course_item {
  width: 277px;
  height: 295px;
  display: flex;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 15px;

}

// .course_item:nth-last-child(-n + 5) {
//   margin-bottom: 0px;
// }
.course_item_content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 5px;

  &:hover {
    box-shadow: 0 3px 18px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
    transition: all 0.3s;
  }
}

.course_type {
  position: absolute;
  left: 5px;
  bottom: 5px;
  width: 54px;
  height: 20px;
  background: rgba(0, 0, 0, 0.5);
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  border-radius: 5px;
}

.item_image_wrapper {
  height: 177px;
  width: 100%;
  position: relative;
  overflow: hidden;

  .item_image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .yearText{
    position: absolute;
    bottom: 0;
    right: 0;
    color: #ffffff;
    background: rgb(22, 113, 218);
    padding: 2px 8px;
    border-radius: 8px 0 0 8px;
    font-size: 14px;
  }
}

.course_desc {
  font-size: 12px;
  height: 118px;
  background-color: #fff;
  padding: 10px;

  .item_text {
    height: 20px;
    font-size: 16px;
    color: #333;
    line-height: 20px;
  }

  .course_detail {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .course-author {
      font-size: 14px;
      color: #666666;
      width: 200px;
    }

    .course-people {
      display: flex;

      img {
        margin-right: 5px;
      }
    }
  }

  .price {
    line-height: 20px;

    .current_price {
      font-size: 16px;
      font-weight: 550;
      color: #F61818;

      &.free {
        color: #C7000B;
      }
    }

    .current_price::before {
      content: '￥';
      font-size: 0.66em;
    }

    .free::before {
      display: none;
    }

    .old_price {
      margin-left: 5px;
      font-size: 12px;
      line-height: 18px;
      color: #999999;
      text-decoration-line: line-through;
    }

    .old_price::before {
      content: '￥';
      font-size: 1em;
    }
  }

  .course_sale {
    font-size: 12px;
    line-height: 18px;
    color: #999999;
  }
}

.image-view {
  width: 100%;
  height: 100%;
  position: absolute;
  top:0;
  left:0;
  //background: url("@/assets/images/new/lan@2x.png") no-repeat;
  //background-size: cover;
  padding: 25px 32px 32px 23px;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  font-weight: bold;

  .line-view {
    background: white;
    width: 18px;
    height: 2px;
  }

  .course-title {
    width: 220px;
    font-size: 22px;
    color: white;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    word-break: break-all;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .course-author {
    font-size: 14px;
    color: white;
    display: flex;

    p {
      margin: 0;
      font-weight: bold;
    }
  }
}

.buy_btn {
  background: #E3F3FF;
  color: #036EB8;
  border: 0;

  &:hover {
    background: #1671DA;
    color: white;
  }
}

.cart_btn{
  background: #F8EBEC;
  color: #C7000B;
  border: 0;

  &:hover {
    background: #E52B0D;
    color: white;
  }
}
.offline_btn {
  width: 100%;
  color: #ffffff;
  font-size: 18px;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  .btn {
    width: 150px;
    background: #3d7fff;
    text-align: center;
    padding: 10px 20px;
    border-radius: 50px;
    cursor: pointer;
  }
  .btn2 {
    width: 150px;
    background: #fff;
    color: #999;
    text-align: center;
    padding: 10px 20px;
    border-radius: 50px;
    border: 1px solid #ccc;
    margin-right: 20px;
    cursor: pointer;
  }
}
.xueshi {
  display: inline-block;
  margin-left: 10px;;
  color:#1b75d5;
  background-color:#f4f8ff;
  border-radius: 50px;
  line-height: 25px;
  width: 70px;
  text-align: center;
}
</style>
